import React, {useState, useEffect} from 'react';
import './App.sass';
import ScrollArea from "./components/ScrollArea/ScrollArea";
import FixedArea from "./components/FixedArea/FixedArea";
import data from './data';
import debounce from "lodash-es/debounce";
import 'url-search-params-polyfill';
import Modal from "./components/Modal/Modal";
import UAParser from 'ua-parser-js';
import { PLATFORM_VENDOR_HUAWEI, PLATFORM_VENDOR_HONOR } from './constants';

const preventer = e => {
    e.preventDefault();
};

const App = () => {
    const breakPoint = 960;
    const {sections, fixed} = data;
    const [isMobile, setMobile] = useState(false);
    const [isScrolling, setScrolling] = useState(false);
    const [smsSendingAvailable, setsmsSendingAvailable] = useState(null);
    const [smsSendingCsrfhash, setSmsSendingCsrfhash] = useState(null);
    const [isOpen, setOpen] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState(null);
    const [showSendLink, setShowSendLink] = useState(false);
    const [isHuawei, setIsHuawei] = useState(false);
    const [platform, setPlatform] = useState('');

    document.title = data.page.title;

    const handleScroll = (time, state) => debounce(() => {
        setScrolling(state);
    }, time);

    useEffect(() => {
        const el = document.querySelector('.app');
        el.addEventListener('scroll', handleScroll(50, true));

        window.innerWidth < breakPoint ? setMobile(true) : setMobile(false);
        window.addEventListener('resize', debounce((e) => {
            e.target.innerWidth > breakPoint ? setMobile(false) : setMobile(true);
        }, 20));
        window.addEventListener('message', (e) => {
            const {method} = e.data;
            if (method && method.name === 'resize') {
                window.landing && window.landing.getViewportSize()
                    .then(({width, height}) => {
                        window.landing && window.landing.setSize({width, height});
                    });
            }
            ;
        });

        const searchParams = new URLSearchParams(window.location.search);
        setSmsSendingCsrfhash(searchParams.get('sms_sending_csrfhash'));
        setsmsSendingAvailable(searchParams.get('sms_sending_available'));

        const useragent = new UAParser().getResult();
        const isHuawei = [PLATFORM_VENDOR_HUAWEI, PLATFORM_VENDOR_HONOR].includes(useragent.device.vendor);
     
        setIsHuawei(Boolean(isHuawei));
        setPlatform(String(useragent.os.name));

        return () => {
            el.removeEventListener('wheel', handleScroll(50, true));
            el.removeEventListener('wheel', handleScroll(500, false));
        };
    }, []);

    useEffect(() => {
        setShowSendLink(!!smsSendingAvailable)
    }, [smsSendingAvailable]);


    useEffect(() => {
        const root = document.querySelector('#root');
        isOpen
            ? root.addEventListener('touchmove', preventer)
            : root.removeEventListener('touchmove', preventer)
    }, [isOpen]);

    const sendMessage = () => {
        window.landing && window.landing.action('mobileSendSms', {
            hash: smsSendingCsrfhash,
        }).then(({phone}) => {
            setPhoneNumber(phone);
            setOpen(true);

        }).catch((error) => {
            setShowSendLink(false);
            console.error(error)
        });
    };

    const handleSetOpen = param => {
        setOpen(param);
        if (param === false) {
            setShowSendLink(false);
        };
    };

    return (
        <div className="app">
            <FixedArea
                fixed={fixed}
                showSendLink={showSendLink}
                sendMessage={sendMessage}
                isHuawei={isHuawei}
                platform={platform}
            />
            <ScrollArea
                sections={sections}
                isScrolling={isScrolling}
            />
            {isMobile &&
                <FixedArea
                    fixed={fixed}
                    forMobile={true}
                    showSendLink={showSendLink}
                    sendMessage={sendMessage}
                    isHuawei={isHuawei}
                    platform={platform}
                />
            }
            <Modal
                qrCodeText={data.fixed.qrCodeText}
                isOpen={isOpen}
                handleSetOpen={handleSetOpen}
                phoneNumber={phoneNumber}
                isHuawei={isHuawei}
            />
        </div>
    );
};

export default App;
